/* eslint-disable max-len */
import { DepartmentModel } from './department.model'
import { User } from './user.model'

export type MessageModel = Common &
  MessageText &
  MessageVideo &
  MessageReaction &
  MessagePhoto &
  MessageSticker &
  MessageAudio &
  MessageDocument

type MessageText = {
  text: { message: string }
}

type MessageVideo = {
  video: Video
}

type Video = {
  videoUrl: string
  caption?: string
  mimeType: string
}

type MessageReaction = {
  reaction: Reaction
}

type Reaction = {
  value: string
  time: number
  reactionBy: string
  referencedMessage: ReferencedMessage
}

type ReferencedMessage = {
  messageId: string
  fromMe: boolean
  phone: string
  participant: any
}

type MessagePhoto = {
  image: Image
}

type Image = {
  base64?: string
  mimeType: string
  imageUrl: string
  thumbnailUrl?: string
  caption?: string
}

type MessageSticker = {
  sticker: Sticker
}

type Sticker = {
  height: number
  mimeType: string
  stickerUrl: string
  width: number
}

type MessageAudio = {
  audio: Audio
}

type Audio = {
  audioUrl: string
  mimeType: string
  seconds?: string
}

type MessageDocument = {
  document: Document
}

type Document = {
  documentUrl: string
  mimeType: string
  title?: string
  pageCount?: number
  fileName?: string
}

type Common = {
  voiceCall?: {
    id: string
    direction: 'INBOUND' | 'OUTBOUND'
    outcome?: string
    state?: string
    channel?: string
    wasConnected: boolean
    durationSeconds: number
    startedAt: string
    endedAt?: string
    claimedBy?: { id?: string; name?: string; email?: string }
    acceptedBy?: { id?: string; name?: string; email?: string }
  }
  poll?: Poll
  isQuickReply?: boolean
  campaignId?: string
  isTemplate?: boolean
  messageContent?: MessageContent[]
  replyMessage?: MessageModel
  editMessage?: MessageModel
  templateMessageId?: string
  messageTypeSent: TemplateType
  ownerId?: string
  senderNumber: string
  messageText: string
  isStatusReply: boolean
  senderLid: string
  connectedPhone: string
  waitingMessage: boolean
  isEdit: boolean
  isGroup: boolean
  isNewsletter: boolean
  messageId: string
  phone: string
  fromMe: boolean
  moment: number
  momment: number
  status: string
  chatName: string
  chatId?: string
  operator?: Operator
  senderPhoto: string
  senderName: string
  participantPhone: any
  participantLid: any
  photo: string
  broadcast: boolean
  type: string
  createdAt: number
  sentAt?: number
  deliveredAt?: number
  readAt?: number
  failedAt?: number
  optionList: OptionList
  stickerUrl?: string
  listResponseMessage: ListResponseMessage
  campanhaId: string
  senderId?: string
  receiverId?: string
  receiverNumber: number | string
  isRead: boolean
  isSend: boolean
  isOfficial?: boolean
  typeFile?: 'sticker' | 'text' | 'audio' | 'attachment' | 'messageTemplate' | 'contact' | 'location' | null
  errors?: Error[]
  caption?: string
  buttonContent: ButtonContent
  files?: FileMessageModel[]
  buttonResponseMessage?: ButtonResponseMessage
  messages?: RawInteractiveMessage[]
  oldMessage?: MessageModel
  nome?: string
  contactsMessage?: ContactMessage[]
  location?: Location
  carouselContent?: CarouselContent[]
  typeSent?: TemplateType
  callPermissionReply?: {
    response?: string
    is_permanent?: boolean
    expiration_timestamp?: number
    response_source?: string
  }
}

type Poll = {
  options: object[]
  question: string
}

type CarouselContent = {
  mimeType?: string
  buttons: Array<{
    type: 'REPLY' | string
    label: string
    phone: string
    url: string | null
    _id: string
  }>
  messageParameters: {
    textBody: string
  }
  buttonsParameter: unknown[]
  fileHash: string
  fileUrl: string
  textBody: string
}

type Location = {
  address?: string
  name: string
  longitude: number
  latitude: number
}

export type FileMessageModel = {
  mimeType: string
  fileUrl: string
  name: string
} & File

type Error = {
  code: number
  title: string
  message: string
  error_data: {
    details: string
  }
  href: string
}

export type Operator = {
  department: Pick<DepartmentModel, 'id' | 'name'>
} & Pick<User, 'id' | 'name'>

export type File = {
  type: string
  typeFile?: string
  name?: string
  size?: number
  url?: any
}

type OptionList = {
  buttonLabel: string
  title: string
  options: Option[]
}

type Option = {
  id: string
  description: string
  title: string
}

type ListResponseMessage = {
  message: string
  selectedRowId: string
  title: string
}

export type MessageTemplateModel = {
  preview?: {
    messages: Array<Partial<MessageModel>>
    contentUnavailable?: boolean
    header?: string
    footer?: string
    mediaUnavailable?: boolean
  }
  id: string
  templateId: string
  messageId: string
  name: string
  category: string
  campaignId: string
  status: string
  typeSent: TemplateType
  components: Component[]
  dateCreated: number
}

type Component = {
  type: string
  text: string
}

type MessageContent = {
  type: string
  messageId: string
  message: string
}

type ButtonContent = {
  msgFooter?: string
  msgHeader?: string
  msgText?: string
  buttons: Button[]
}

type Button = {
  id: string
  label: string
  phone: string
  value?: any
  type: 'URL' | 'CALL'
  url: string
}

type ButtonResponseMessage = {
  button: ButtonResponse
  messageId: string
  oldMessage: OldMessage
}

type ButtonResponse = {
  payload: string
  text: string
}

type RawInteractiveMessage = {
  type: string
  interactive?: {
    type: string
    button_reply?: {
      id: string
      title: string
    }
    call_permission_reply?: MessageModel['callPermissionReply']
  }
}

type ContactMessage = {
  name: {
    first_name?: string
    last_name?: string
    formatted_name: string
    description?: string
  }
  phones: Array<{
    phone: string
    wa_id?: string
    type?: 'MOBILE'
  }>
}

type OldMessage = {
  id: string
} & MessageModel

export enum TemplateType {
  BLANK = '',
  ENVIAR_CONTATO = 'ENVIAR_CONTATO',
  SEND_LOCATION = 'SEND_LOCATION',

  CALL_PERMISSION_REQUEST_SEM_PARAMETRO = 'CALL_PERMISSION_REQUEST_SEM_PARAMETRO',
  CALL_PERMISSION_REQUEST_COM_PARAMETRO = 'CALL_PERMISSION_REQUEST_COM_PARAMETRO',

  COPY_CODE_COM_BOTAO_SEM_PARAMETRO_COM_TEMPLATE = 'COPY_CODE_COM_BOTAO_SEM_PARAMETRO_COM_TEMPLATE',

  FLOW_TEMPLATE_COM_TEMPLATE_SEM_PARAMETRO = 'FLOW_TEMPLATE_COM_TEMPLATE_SEM_PARAMETRO',
  TEXTO_SEM_BOTAO_SEM_PARAMETRO_SEM_MIDIA = 'TEXTO_SEM_BOTAO_SEM_PARAMETRO_SEM_MIDIA',
  TEXTO_SEM_BOTAO_COM_PARAMETRO_SEM_MIDIA = 'TEXTO_SEM_BOTAO_COM_PARAMETRO_SEM_MIDIA',

  TEXTO_COM_BOTAO_SEM_PARAMETRO_SEM_MIDIA = 'TEXTO_COM_BOTAO_SEM_PARAMETRO_SEM_MIDIA',
  TEXTO_COM_BOTAO_COM_PARAMETRO_SEM_MIDIA = 'TEXTO_COM_BOTAO_COM_PARAMETRO_SEM_MIDIA',

  TEXTO_SEM_BOTAO_SEM_PARAMETRO_COM_MIDIA = 'TEXTO_SEM_BOTAO_SEM_PARAMETRO_COM_MIDIA',
  TEXTO_SEM_BOTAO_COM_PARAMETRO_COM_MIDIA = 'TEXTO_SEM_BOTAO_COM_PARAMETRO_COM_MIDIA',

  TEXTO_COM_BOTAO_SEM_PARAMETRO_COM_MIDIA = 'TEXTO_COM_BOTAO_SEM_PARAMETRO_COM_MIDIA',
  TEXTO_COM_BOTAO_COM_PARAMETRO_COM_MIDIA = 'TEXTO_COM_BOTAO_COM_PARAMETRO_COM_MIDIA',

  SOMENTE_TEXTO_SEM_TEMPLATE_SEM_PARAMETRO = 'SOMENTE_TEXTO_SEM_TEMPLATE_SEM_PARAMETRO',
  SOMENTE_TEXTO_SEM_TEMPLATE_COM_PARAMETRO = 'SOMENTE_TEXTO_SEM_TEMPLATE_COM_PARAMETRO',
  SOMENTE_TEXTO_COM_MIDIA_SEM_TEMPLATE_COM_PARAMETRO = 'SOMENTE_TEXTO_COM_MIDIA_SEM_TEMPLATE_COM_PARAMETRO',
  SOMENTE_MIDIA_SEM_TEMPLATE_COM_PARAMETRO = 'SOMENTE_MIDIA_SEM_TEMPLATE_COM_PARAMETRO',
  SOMENTE_TEXTO_COM_MIDIA_SEM_TEMPLATE_SEM_PARAMETRO = 'SOMENTE_TEXTO_COM_MIDIA_SEM_TEMPLATE_SEM_PARAMETRO',
  SOMENTE_MIDIA_SEM_TEMPLATE_SEM_PARAMETRO = 'SOMENTE_MIDIA_SEM_TEMPLATE_SEM_PARAMETRO',
  SOMENTE_TEXTO_COM_BOTAO_SEM_TEMPLATE_COM_PARAMETRO = 'SOMENTE_TEXTO_COM_BOTAO_SEM_TEMPLATE_COM_PARAMETRO',
  SOMENTE_BOTAO_SEM_TEMPLATE_COM_PARAMETRO = 'SOMENTE_BOTAO_SEM_TEMPLATE_COM_PARAMETRO',
  SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_SEM_TEXTO_COM_PARAMETRO = 'SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_SEM_TEXTO_COM_PARAMETRO',
  SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_COM_TEXTO_COM_PARAMETRO = 'SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_COM_TEXTO_COM_PARAMETRO',
  SOMENTE_TEXTO_COM_BOTAO_SEM_TEMPLATE_SEM_PARAMETRO = 'SOMENTE_TEXTO_COM_BOTAO_SEM_TEMPLATE_SEM_PARAMETRO',
  SOMENTE_BOTAO_SEM_TEMPLATE_SEM_PARAMETRO = 'SOMENTE_BOTAO_SEM_TEMPLATE_SEM_PARAMETRO',
  SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_SEM_TEXTO_SEM_PARAMETRO = 'SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_SEM_TEXTO_SEM_PARAMETRO',
  SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_COM_TEXTO_SEM_PARAMETRO = 'SOMENTE_MIDIA_COM_BOTAO_SEM_TEMPLATE_COM_TEXTO_SEM_PARAMETRO',
  URL_DINAMICA_SEM_PARAMETRO = 'URL_DINAMICA_SEM_PARAMETRO',
  URL_DINAMICA_COM_PARAMETRO = 'URL_DINAMICA_COM_PARAMETRO',
  NOTIFICAR_CONTATOS_SEM_TEMPLATE_SEM_PARAMETRO = 'NOTIFICAR_CONTATOS_SEM_TEMPLATE_SEM_PARAMETRO',
  NOTIFICAR_CONTATOS_SEM_TEMPLATE_COM_PARAMETRO = 'NOTIFICAR_CONTATOS_SEM_TEMPLATE_COM_PARAMETRO',
  SOMENTE_TEXTO_ESPERA_RESPOSTA = 'SOMENTE_TEXTO_ESPERA_RESPOSTA',
  LISTA_OPCOES = 'LISTA_OPCOES',
  ONLY_AUDIO = 'ONLY_AUDIO',
  ONLY_IMAGE = 'ONLY_IMAGE',
  ONLY_VIDEO = 'ONLY_VIDEO',
  TEXTO_COM_MIDIA_COM_PARAMETRO_COM_BOTAO_PARAMETRO = 'TEXTO_COM_MIDIA_COM_PARAMETRO_COM_BOTAO_PARAMETRO',
  TEXTO_SEM_MIDIA_SEM_PARAMETRO_COM_BOTAO_PARAMETRO = 'TEXTO_SEM_MIDIA_SEM_PARAMETRO_COM_BOTAO_PARAMETRO',
  TEXTO_COM_MIDIA_SEM_PARAMETRO_COM_BOTAO_PARAMETRO = 'TEXTO_COM_MIDIA_SEM_PARAMETRO_COM_BOTAO_PARAMETRO',
  TEXTO_SEM_MIDIA_COM_PARAMETRO_COM_BOTAO_PARAMETRO = 'TEXTO_SEM_MIDIA_COM_PARAMETRO_COM_BOTAO_PARAMETRO',
  TEXTO_COM_CATALOGO_COM_PARAMETRO_COM_TEMPLATE = 'TEXTO_COM_CATALOGO_COM_PARAMETRO_COM_TEMPLATE',
  TEXTO_COM_CATALOGO_SEM_PARAMETRO_COM_TEMPLATE = 'TEXTO_COM_CATALOGO_SEM_PARAMETRO_COM_TEMPLATE',
  TEXTO_COM_CATALOGO_COM_PARAMETRO_SEM_TEMPLATE = 'TEXTO_COM_CATALOGO_COM_PARAMETRO_SEM_TEMPLATE',
  TEXTO_COM_CATALOGO_SEM_PARAMETRO_SEM_TEMPLATE = 'TEXTO_COM_CATALOGO_COM_PARAMETRO_SEM_TEMPLATE',
  CARROSSEL_CARD_COM_PARAMETRO = 'CARROSSEL_CARD_COM_PARAMETRO',
  CARROSSEL_CARD_SEM_PARAMETRO = 'CARROSSEL_CARD_SEM_PARAMETRO'
}
